// extracted by mini-css-extract-plugin
export default {"wrap":"tooltip_wrap__Vz7hC"};